<template>
  <span class="id-cell" :class="{ 'id-cell--pier': $store.state.toggleSite === 'rbxpier' }" v-if="value">
    <span
      class="id-cell__text"
      :class="{ 'id-cell__text--link': clickable }"
      :title="clickable ? `${value} — открыть` : value"
      @click="clickable && $emit('open')"
    >
      {{ short }}
    </span>
    <button
      type="button"
      class="id-cell__copy"
      :class="{ 'is-copied': copied }"
      :title="copied ? 'Скопировано' : 'Скопировать'"
      @click.stop="copy"
    >
      <svg v-if="!copied" width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="8" y="8" width="13" height="13" rx="2.5" stroke="currentColor" stroke-width="2" />
        <path
          d="M16 8V5.5A2.5 2.5 0 0 0 13.5 3h-8A2.5 2.5 0 0 0 3 5.5v8A2.5 2.5 0 0 0 5.5 16H8"
          stroke="currentColor"
          stroke-width="2"
        />
      </svg>
      <svg v-else width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5 12.5l4.5 4.5L19 7"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  </span>
  <span v-else>—</span>
</template>

<script>
import "./idCell.scss";

// ID в таблицах: показываем хвост, полный — в title и в буфер по иконке
export default {
  name: "IdCell",
  props: {
    value: { type: [String, Number], default: "" },
    tail: { type: Number, default: 8 },
    // Клик по тексту открывает связанную запись (например, заказ из пополнения)
    clickable: { type: Boolean, default: false }
  },
  data() {
    return { copied: false };
  },
  computed: {
    short() {
      const full = String(this.value);
      // ID пополнений и трансферов склеены: свой ObjectId + ObjectId пользователя.
      // Хвост берём у своей половины, иначе у всех записей одного юзера он одинаковый. Копируется целиком.
      const text = /^[a-f0-9]{48}$/i.test(full) ? full.slice(0, 24) : full;
      return text.length > this.tail + 1 ? `…${text.slice(-this.tail)}` : text;
    }
  },
  methods: {
    async copy() {
      const text = String(this.value);
      try {
        await navigator.clipboard.writeText(text);
      } catch (error) {
        // Clipboard API недоступен вне https — копируем через выделение
        const area = document.createElement("textarea");
        area.value = text;
        area.style.position = "fixed";
        area.style.opacity = "0";
        document.body.appendChild(area);
        area.select();
        document.execCommand("copy");
        document.body.removeChild(area);
      }
      this.copied = true;
      clearTimeout(this.copiedTimer);
      this.copiedTimer = setTimeout(() => {
        this.copied = false;
      }, 1200);
    }
  },
  beforeDestroy() {
    clearTimeout(this.copiedTimer);
  }
};
</script>
